import styled from "styled-components";

//memperkecil style component
const StyleCard = styled.div` 
     margin: 1rem;
     text-align: center;
    

.cards__items {
    background-color: rgba(6, 214, 160, 1);
    float: left;
    text-align: center;
    width: 300px;
    height: 130px;
    margin: 15px;
    border-radius: 15px;
    margin-top: 10px;
    color: white;
    font-family :'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  
}


.cards__descOne {
    color:rgb(255, 200, 0);
    font-weight: bold;
    font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;

    
}

.cards__descTwo {
    color: blue;
    font-weight: bold;
    font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
}

.cards__descThree {
    color: red;
    font-weight: bold;
    font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
} 

.two__justify{
    text-align: justify;
    margin-top: 30px;
    justify-content: center;
}
  


/* Large Screen */
@media (min-width: 992px) {
    .container{
        text-align: left;
        max-width: 1200px;
        margin: 0 auto;
        justify-content: space-around;
        flex-wrap: wrap;
        padding: 10px;
        margin: 30px auto;
        display: flex;
        margin-top: 10px;


    }


}
    
`;

export default StyleCard;